import React from 'react';
import {
  Button
} from 'react95';


const Sites = [{
  name: 'YouTube',
  Link: 'https://www.youtube.com/@XaragameIsHere',
Image: 'images/youboob.png',
}, {
    name: 'Itch',
    Link: 'https://xaragame.itch.io/',
    Image: 'images/itch.png',
}, {
    name: 'Steam',
    Link: 'https://steamcommunity.com/id/Za-ra-game/',
    Image: 'images/steam.png',
}, {
    name: 'Instagram',
    Link: 'https://instagram.com/xaragameishere?igshid=NTc4MTIwNjQ2YQ==',
    Image: 'images/Instagram-Icon.png',
}, {
    name: 'Ko-Fi',
    Link: 'https://ko-fi.com/xaragame',
    Image: 'images/kofi.png',
}, {
    name: 'Discord',
    Link: 'https://discord.com/users/441424104260763661',
    Image: 'images/discord.png',
}, {
    name: 'TikTok',
    Link: 'https://www.tiktok.com/@xaragameishere',
    Image: 'images/tiktok.png',
}];



const List = () => {
    function linkOut(link)
    {
        window.location.href=link;
    }
    
    const listItems = Sites.map(Site =>
        <Button
        onClick={() => {linkOut(Site.Link)}}
            style={{ flex: '1 1 auto', maxWidth: '20px', height: 'auto', padding: "10px" }}
            fstyle={{ width: '100%', height: '100%', padding: 0 }}
        >
        <img
        src={Site.Image}
        alt={Site.Name}
        style={{ display: 'block', width: '100%', height: 'auto' }}
        />
        </Button>
    
  );
    return <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>{listItems}</div>;
}

export default List;
